<template>
  <v-card class="card-pad mx-auto" width="900px">
    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="white"
          style="width: 100%"
        >
          <h3 class="mb-1">{{ $t('Atenção') }}</h3>
          <v-divider class="mb-2"></v-divider>
          <p class="text-body-2 black--text text--darken-1 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </p>

          <div class="d-flex justify-space-between">
            <v-btn
              depressed
              class="ma-1 secondary-button"
              style="color: white; background-color: #b14949 !important"
              @click="alterDialog = false"
            >
              {{ $t('Não') }}
            </v-btn>

            <v-btn
              depressed
              class="ma-1 primary-button"
              style="color: white; background-color: #0f3582 !important"
              @click="closeDialog"
            >
              {{ $t('Sim') }}
            </v-btn>
          </div>
        </v-sheet>
      </div>
    </v-dialog>

    <v-btn absolute top right depressed dark icon @click="close">
      <v-icon color="#bbb">mdi-close</v-icon>
    </v-btn>

    <div class="d-flex justify-center my-3">
      <h2>{{ $t(title) }}</h2>
    </div>

    <v-divider class="ma-6 my-2"></v-divider>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
        >
          <v-row class="ma-0 mx-6" dense>
            <v-col class="pb-0" cols="12">
              <label class="label">{{ $t('Item checklist') }}</label>
              <v-text-field
                hide-details="auto"
                name="name"
                v-model="currentChecklistItem.name"
                :rules="nameRules"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12">
              <label class="label">{{ $t('Classe') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="checklistItemClassId"
                :items="checklistItemClasses"
                item-value="id"
                item-text="name"
                :loading="classLoading"
                :rules="classRules"
                outlined
                class="primary-input"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="d-flex align-center py-0">
              <label class="label"> {{ $t('Item padrão') }} </label>
              <v-switch
                inset
                hide-details
                :disabled="institution.userType > 0"
                v-model="currentChecklistItem.isPattern"
                :label="`${
                  currentChecklistItem.isPattern ? $t('Sim') : $t('Não')
                }`"
                color="#BBCF20"
                class="mx-4 mt-0 mb-3 label"
              >
              </v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon size="60" color="success">
            mdi-checkbox-marked-circle
          </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              isEditing
                ? $t('Item de checklist atualizado com sucesso!')
                : $t('Item de checklist cadastrado com sucesso!')
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider class="mb-6 mt-2 mx-8"></v-divider>

    <div class="d-flex mx-6">
      <v-btn
        depressed
        @click="close"
        v-if="step === 0"
        class="secondary-button"
      >
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        class="primary-button mr-0"
        @click="next"
        :loading="loading"
      >
        {{ $t(buttonText) }}
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  props: {
    title: String,
    checklistItem: Object,
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id

    this.getChecklisItemClasses()
    this.user = JSON.parse(localStorage.getItem('user'))

    if (this.checklistItem) {
      this.currentChecklistItem = this.checklistItem
      this.checklistItemClassId = this.checklistItem.checklistItemClassId
      this.isEditing = true
    }
  },

  data: () => ({
    step: 0,
    user: {},
    institutionId: '',
    errorMessage: '',
    loading: false,
    classLoading: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    checklistItemClassId: null,
    checklistItemClasses: [],
    currentChecklistItem: {
      id: 0,
      name: '',
      isPattern: false,
    },
    nameRules: [
      (v) => !!v || 'Item checklist requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Item checklist deve ter no máximo 128 caracteres',
    ],
    classRules: [(v) => !!v || 'Classe do item requerida'],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return ''
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const checklistItem = {
        Id: this.currentChecklistItem.id,
        Name: this.currentChecklistItem.name,
        ChecklistItemClassId: this.checklistItemClassId,
        isPattern: this.currentChecklistItem.isPattern,
        institutionId: this.institutionId,
      }

      let url = 'checklistItem/add'

      if (this.isEditing) {
        url = 'checklistItem/edit'
      }

      await this.apiService
        .post(url, checklistItem)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },

    async getChecklisItemClasses() {
      this.classLoading = true

      await this.apiService
        .get(`checklistItemClass/list/${this.institutionId}`)
        .then((resposne) => {
          this.checklistItemClasses = resposne.content
          this.classLoading = false
        })
    },
  },

  watch: {
    currentChecklistItem: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
</script>
